const capcourseActions = {
  GET_ALL_CAPCOURSE: "GET_ALL_CAPCOURSE",
  SET_ALL_CAPCOURSE: "SET_ALL_CAPCOURSE",

  GET_CAP_CANDIDATEDETAILS: "GET_CAP_CANDIDATEDETAILS",
  SET_CAP_CANDIDATEDETAILS: "SET_CAP_CANDIDATEDETAILS",

  GET_CAP_CANDIDATEADDRESSDETAILS: "GET_CAP_CANDIDATEADDRESSDETAILS",
  SET_CAP_CANDIDATEADDRESSDETAILS: "SET_CAP_CANDIDATEADDRESSDETAILS",

  GET_CAP_CANDIDATEACADAMICDETAILS: "GET_CAP_CANDIDATEACADAMICDETAILS",
  SET_CAP_CANDIDATEACADAMICDETAILS: "SET_CAP_CANDIDATEACADAMICDETAILS",

  GET_CAP_CANDIDATERESERVATIONDETAILS: "GET_CAP_CANDIDATERESERVATIONDETAILS",
  SET_CAP_CANDIDATERESERVATIONDETAILS: "SET_CAP_CANDIDATERESERVATIONDETAILS",

  GET_CAP_CANDIDATEUPLOADDETAILS: "GET_CAP_CANDIDATEUPLOADDETAILS",
  SET_CAP_CANDIDATEUPLOADDETAILS: "SET_CAP_CANDIDATEUPLOADDETAILS",

  GET_SCOREDETAILS: "GET_SCOREDETAILS",
  SET_SCOREDETAILS: "SET_SCOREDETAILS",

  SET_CAP_CANDIDATURE: "SET_CAP_CANDIDATURE",
  GET_CAP_CANDIDATURE: "GET_CAP_CANDIDATURE",

    GET_SCOREDETAILS:'GET_SCOREDETAILS',
    SET_SCOREDETAILS:'SET_SCOREDETAILS',


    GET_CAP_CANDIDATE_DOCUMENTS:'GET_CAP_CANDIDATE_DOCUMENTS',
    SET_CAP_CANDIDATE_DOCUMENTS:'SE_CAP_CANDIDATE_DOCUMENTS',

    CAP_UPLOADS_DOCUMENTS_CREATION : 'CAP_UPLOADS_DOCUMENTS_CREATION',
    CAP_UPLOADS_DOCUMENTS_REMOVE : 'CAP_UPLOADS_DOCUMENTS_REMOVE',

    

    SET_CAP_CATEGORY: "SET_CAP_CATEGORY",
    GET_CAP_CATEGORY: "GET_CAP_CATEGORY",

  INSERT_CAP_CANDIDATURE:"INSERT_CAP_CANDIDATURE",

  UPDATE_CAP_CANDIDATE_PERSONAL:"UPDATE_CAP_CANDIDATE_PERSONAL",
  UPDATE_CAP_CANDIDATE_ADDRESS:"UPDATE_CAP_CANDIDATE_ADDRESS",
  UPDATE_CAP_CANDIDATE_RESERVATION:"UPDATE_CAP_CANDIDATE_RESERVATION",
  UPDATE_CAP_CANDIDATE_ACADEMIC:"UPDATE_CAP_CANDIDATE_ACADEMIC",
  UPDATE_CAP_CANDIDATE_UPLOADS:"UPDATE_CAP_CANDIDATE_UPLOADS",

  GET_CAP_MASTER_FIELDS : 'GET_CAP_MASTER_FIELDS',
  
  GET_CANDIDATE_CAP_REG_DETAILS : 'GET_CANDIDATE_CAP_REG_DETAILS',
  SET_CANDIDATE_CAP_REG_DETAILS : 'SET_CANDIDATE_CAP_REG_DETAILS'

};

export default capcourseActions;
